<template>
  <v-app>
    <!-- HEADER -->
    <Header
      v-if="!isCheckoutPage"
      @scroll-to-packages="handleScrollToPackages"
      @scroll-to-footer="handleScrollToFooter"
      @scroll-to-hero="handleScrollToHero"
    />

    <!-- MAIN CONTENT -->
    <v-main>
      <router-view ref="mainRouterView" @scroll-to-packages="handleScrollToPackages" />
    </v-main>

    <!-- FOOTER -->
    <Footer v-if="!isCheckoutPage" ref="appFooter" />

    <!-- FLOATING WHATSAPP -->
    <a
      v-if="!isCheckoutPage"
      href="https://wa.me/917356449135"
      class="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <v-icon color="white" size="30">mdi-whatsapp</v-icon>
    </a>

    <!-- OPTIONAL AI COMPONENT -->
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: { Header, Footer },

  computed: {
    isCheckoutPage() {
      return (
        this.$route.name === 'Failure' ||
        this.$route.name === 'Success' ||
        this.$route.name === 'PaywaitScreen' ||
        this.$route.name === 'NotFound' ||
        this.$route.path.includes('checkout')
      );
    },
  },

  methods: {
    handleScrollToPackages() {
      if (this.$refs.mainRouterView && this.$refs.mainRouterView.handleScrollToPackages) {
        this.$refs.mainRouterView.handleScrollToPackages();
        return;
      }

      const packagesSection =
        document.querySelector('[ref="packagesSection"]') ||
        document.querySelector('.packages-section') ||
        document.getElementById('packages-section');

      if (packagesSection) {
        packagesSection.scrollIntoView({ behavior: 'smooth' });
        return;
      }

      this.$root.$emit('scroll-to-packages');
    },

    handleScrollToFooter() {
      this.$nextTick(() => {
        const footer =
          this.$refs.appFooter?.$el ||
          document.querySelector('.v-footer') ||
          document.querySelector('.contact-wrapper');

        if (footer) {
          this.waitForContentLoad().then(() => {
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: 'smooth',
            });
          });
        } else {
          setTimeout(() => {
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: 'smooth',
            });
          }, 300);
        }
      });
    },

    waitForContentLoad() {
      return new Promise((resolve) => {
        const images = document.querySelectorAll('img');

        const imagePromises = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();

          return new Promise((res) => {
            img.addEventListener('load', res);
            img.addEventListener('error', res);
            setTimeout(res, 1000);
          });
        });

        Promise.all(imagePromises).then(() => {
          setTimeout(resolve, 200);
        });
      });
    },

    handleScrollToHero() {
      this.$nextTick(() => {
        const heroSection =
          document.querySelector('[ref="heroSection"]') ||
          document.querySelector('.hero-new') ||
          document.getElementById('hero-section');

        if (heroSection) {
          heroSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    },
  },
};
</script>

<style>
.whatsapp-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  transition: all 0.3s ease;
  text-decoration: none;
}

.whatsapp-float:hover {
  background-color: #1ebe5d;
  transform: translateY(-3px);
}

.v-main {
  padding-top: 80px;
}
</style>
